module.exports = __webpack_public_path__ + "static/hero-bg-image-745433c41abf4cd225fe74f32ce6312f.png";